import { queryOptions, useQuery } from '@tanstack/react-query';
import { type RespondedType, responseScheme } from '@/models/response';
import { type UserInfoType, userInfoSchema } from '@/models/user/user-info';
import { fetcher } from '@/utils/fetcher';

export type UserInfoResponseType = RespondedType & {
  UserInfo: UserInfoType;
};

export const userInfoQueryOptions = queryOptions({
  queryKey: ['/GetUserInfo'],
  queryFn: ({ signal }) =>
    fetcher<UserInfoResponseType>('/GetUserInfo', undefined, {
      signal,
      schema: useUserInfoScheme,
      validResponseCodes: [0],
    }).then((response) => response?.UserInfo ?? null),
});

export default function useUserInfo() {
  return useQuery(userInfoQueryOptions);
}

const useUserInfoScheme = responseScheme.extend({
  UserInfo: userInfoSchema,
});
